module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "2010-11-08T18-23-50-706_9781550924589_0034_001",
      "id": "d14e556",
      "src": "Images/2010-11-08T18-23-50-706_9781550924589_0034_001.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1c",
    attrs: {
      "id": "d7e264334"
    }
  }, [_c('span', [_vm._v("collards")])]), _vm._v(" "), _c('p', {
    staticClass: "txca",
    attrs: {
      "id": "d7e264834"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c48_r1#d7e879389",
      "id": "d14e560",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("caldo verde")])])]), _vm._v(" "), _c('p', {
    staticClass: "txca",
    attrs: {
      "id": "d7e2644834"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c85_r1#d7e13189129",
      "id": "d14e563",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("spiced lentils and collard greens")])])]), _vm._v(" "), _c('p', {
    staticClass: "txca",
    attrs: {
      "id": "d7e2584834"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c105_r1#d7e16011149",
      "id": "d14e566",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("feijoada")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f3cf5cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Morg_9781550924589_epub_c15_r1.vue
// module id = 102
// module chunks = 0